import { render, staticRenderFns } from "./vipPlanFnew.vue?vue&type=template&id=bace2cc6&scoped=true&"
import script from "./vipPlanFnew.vue?vue&type=script&lang=ts&"
export * from "./vipPlanFnew.vue?vue&type=script&lang=ts&"
import style0 from "./vipPlanFnew.vue?vue&type=style&index=0&id=bace2cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace2cc6",
  null
  
)

export default component.exports